// FivePointPlaneMarker.js
import { GalleryMarkerBase } from './GalleryMarkerBase.js';

export class FivePointPlaneMarker extends GalleryMarkerBase {
    draw(map) {
        if (this.points.length !== 5) return;

        const emptyPolyPath = [this.points[0], this.points[1], this.points[2], this.points[4], this.points[3], this.points[1], this.points[2], this.points[0] ];
        // 5: [1, 2, 4, 3, 1]
        const filledPolyPath = [this.points[1], this.points[2], this.points[4], this.points[3], this.points[1] ];

        const emptyPolygon = new google.maps.Polygon({
            paths: emptyPolyPath,
            strokeColor: this.options.color,
            strokeOpacity: 0.7,
            strokeWeight: 1,
            fillOpacity: 0,
            map,
            zIndex: this.options.zIndex
        });

        const filledPolygon = new google.maps.Polygon({
            paths: filledPolyPath,
            strokeColor: this.options.color,
            strokeOpacity: 0,
            strokeWeight: 0,
            fillColor: this.options.color,
            fillOpacity: 0.5,
            map,
            zIndex: this.options.zIndex
        });

        const originMarker = this.applyOffset(this.points[0]);
        const marker = this.createOriginMarker(originMarker);

        this.drawnElements.push(emptyPolygon, filledPolygon, marker);
    }
}